import { useEvent } from "../../../context/EventContext";
import defaultBanner from "../../../assest/defaultProfile.png";
import { useEffect, useMemo, useState } from "react";

// Component to display the main event details.
// If the selectedEvent is not present or is not an array, it displays a message saying that the main event details are not found.

const MainEvent = ({ onNext }) => {
  const { selectedEvent, formattedDate, formattedTime } = useEvent();
  const [isRegistrationStarted, setIsRegistrationStarted] = useState(false);

  // Use useMemo to memoize the main event details and avoid unnecessary recalculations
  const mainEventEventDetails = useMemo(
    () => (selectedEvent && selectedEvent[0] ? selectedEvent[0] : null),
    [selectedEvent]
  );

  useEffect(() => {
    if (mainEventEventDetails?.registration_start_date) {
      const registrationStartDate = new Date(
        mainEventEventDetails.registration_start_date
      );
      const currentDate = new Date();

      // Reset time to 00:00:00 to only compare the date
      registrationStartDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);

      // Disable the register button if the registration start date has passed or is today
      if (registrationStartDate.getTime() <= currentDate.getTime()) {
        setIsRegistrationStarted(true); // Disable the button
      } else {
        setIsRegistrationStarted(false); // Enable the button
      }
    }
  }, [mainEventEventDetails]);

  // Check if selectedEvent is not null and is an array
  if (!mainEventEventDetails) {
    return (
      <h1 style={{ paddingLeft: "300px" }}>Main event Details not found.</h1>
    );
  }

  return (
    <div className="main-event-details">
      <div className="event-details">
        <div className="image-container">
          <img
            className="event-banner"
            src={
              mainEventEventDetails.image_url
                ? mainEventEventDetails.image_url
                : defaultBanner
            }
            alt="event-banner"
          />
        </div>
        <p>
          Event Name:<span>{mainEventEventDetails.event_name}</span>
        </p>
        <p>
          Event Type:<span>{mainEventEventDetails.event_type}</span>
        </p>
        <p>
          About:
          <span>{mainEventEventDetails.description}</span>
        </p>
        <p>
          Date:
          <span>
            {formattedDate(mainEventEventDetails.eventDuration[0].start)} |{" "}
            {formattedDate(
              mainEventEventDetails.eventDuration[
                mainEventEventDetails.eventDuration.length - 1
              ].end
            )}
          </span>
        </p>
        <p>
          Time:
          <span>
            {formattedTime(mainEventEventDetails.eventDuration[0].start)} -{" "}
            {formattedTime(mainEventEventDetails.eventDuration[0].end)}
          </span>
        </p>
        <p>
          Venue Details:<span>{mainEventEventDetails.location}</span>
        </p>
        <p>
          Venue Type:<span>{mainEventEventDetails.venue_type}</span>
        </p>
        <p>
          Capacity:<span>{mainEventEventDetails.capacity} people</span>
        </p>
        <button
          onClick={onNext}
          className="register"
          disabled={isRegistrationStarted}
          style={{ cursor: isRegistrationStarted ? "not-allowed" : "pointer" }}
        >
          Register
        </button>
      </div>
    </div>
  );
};

export default MainEvent;
